__turbopack_context__.v({
  "Buttons": "ToggleView-module-scss-module__5HtdPq__Buttons",
  "ButtonsWrapper": "ToggleView-module-scss-module__5HtdPq__ButtonsWrapper",
  "IsVisible": "ToggleView-module-scss-module__5HtdPq__IsVisible",
  "View1": "ToggleView-module-scss-module__5HtdPq__View1",
  "View2": "ToggleView-module-scss-module__5HtdPq__View2",
});
